export default "__VITE_ASSET__BMFiyqJS__"